/**
 * Send the client email, then complete the review when the reviewer asked for it (FB-10, Christian 2026-10-29).
 *
 * A failed send rejects, so the dialog stays open with the draft. A failed completion does NOT reject: the email
 * has already left, and a rejection would keep the dialog open and invite a second send. It is reported instead.
 */
export async function sendThenComplete(opts: {
  alsoComplete: boolean;
  send: () => Promise<unknown>;
  complete: () => Promise<unknown>;
}): Promise<{ completed: true } | { completed: false; completeError?: unknown }> {
  await opts.send();
  if (!opts.alsoComplete) return { completed: false };
  try {
    await opts.complete();
    return { completed: true };
  } catch (completeError) {
    return { completed: false, completeError };
  }
}
